// extracted by mini-css-extract-plugin
module.exports = {"toggle":"RequirementItem_toggle__DDPWW","toggleText":"RequirementItem_toggleText__SqBru"};